import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsive } from '@common-fe/common-fe';

import { Roles } from '@/common/constants';
import ROUTES from '@/common/routes';
import { useApplyFixedScroll } from '@/modules/core/components/DashboardWrapper/hooks';
import { useBreadcrumbs, useHasAccess, useRedirectHome } from '@/modules/core/hooks';
import NewInvestments from '@/modules/investments/NewInvestments';
import { useMyEnrollments } from '@/modules/transaction';
import { useQueryParams } from '@/utils';

const QUERY_KEY = 'id';

const NewInvestmentsPage = () => {
  const { t } = useTranslation();
  const query = useQueryParams();
  const accountId = useMemo(() => query.get(QUERY_KEY) || '', [query]);
  const isInvestmentsDisabled = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);
  useRedirectHome(isInvestmentsDisabled);
  const { breadcrumbAccountTitle } = useMyEnrollments(accountId);
  const { isMobile } = useResponsive();
  useBreadcrumbs(
    [
      {
        key: ROUTES.HOME,
        title: t('Home'),
        value: ROUTES.HOME,
      },
      {
        key: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
        title: breadcrumbAccountTitle,
        value: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
      },
      {
        key: `${ROUTES.INVESTMENTS}?id=${accountId}`,
        title: t('Investments'),
        isMobileMode: isMobile,
        isMobileSubtitleButton: isMobile,
        value: `${ROUTES.INVESTMENTS}?id=${accountId}`,
      },
    ],
    true
  );
  useApplyFixedScroll();
  return <NewInvestments accountId={accountId} />;
};

export default NewInvestmentsPage;
